import { render, staticRenderFns } from "./videodan.vue?vue&type=template&id=0cabfa16&scoped=true"
import script from "./videodan.vue?vue&type=script&lang=js"
export * from "./videodan.vue?vue&type=script&lang=js"
import style0 from "./videodan.vue?vue&type=style&index=0&id=0cabfa16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.27_css-loader@6.11.0_webpack@5.104.1__lodash@4.17.23_headix2sp25l5o3ug274cuzz24/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cabfa16",
  null
  
)

export default component.exports